import BasePage from '../../components/base-page/base-page';
import BlogSearch from '../../components/search/search';
import Share from '../../../shared/utils/share/share';
import SideScrollingBanner from '../../components/side-scrolling-banner/side-scrolling-banner';
import defineBlogAppBannerElement from '../../components/blog-app-banner/blog-app-banner';
import GoUpButton from '../../components/go-up-button/go-up-button';

import './post.scss';

class PostPage extends BasePage {
  ui = {
    articleTitle: '.js-article-title',
  }

  uiCollections = {
    contentBannerButton: '.js-promo-banner-cta',
  }

  events = {
    'click @uiCollections.contentBannerButton': 'handleContentBannerButtonClick',
  }

  onInit() {
    super.onInit();
    new BlogSearch().init();
    new Share().init();
    new SideScrollingBanner().init();
    new GoUpButton(this.ui.articleTitle).init();

    defineBlogAppBannerElement();
  }

  handleContentBannerButtonClick = (e) => {
    e.preventDefault();
    this.signupModal.open();
  }
}

export default PostPage;

PostPage.initOnDomLoaded();
